import React from "react";
import { List, Dropdown, Menu, Icon } from "antd";
import {getData} from "../../../components/Charts/chartData";
import SkillChart from "../../../components/Charts/SkillChart";
import PieChart from "../../../components/Charts/PieChart/PieChartSimple";
import BarChart from "../../../components/Charts/BarChartSimple";
import { Link } from "react-router-dom";

const getChartForm = item => {
  switch (item.type) {
    case "profile":
      return {
        headline: "Transactional Analysis",
        chart: <PieChart data={item} />,
        link: "/profile/survey/" + item.id + "/results"
      };
    case "twentyfivesections":
      return {
        headline: "Transactional Analysis - 24 Questions Driver",
        chart: <BarChart data={item} color={"#82ca9d"} />,
        link: "/twentyfivesections/survey/" + item.id + "/results"
      };
    case "twelvesections":
      return {
        headline: "Transactional Analysis - 12 Sections Driver",
        chart: <BarChart data={item} color={"#0eb89a"} />,
        link: "/twelvesections/survey/" + item.id + "/results"
      };
    default:
      return {
        headline: "Leadership Evaluation",
        chart: (
          <SkillChart
            chartHeight="150px"
            data={getData(item)}
            domain={[]}
            disableLegend
            disableAxisLine
            disableTick
          />
        ),
        link: "/360/survey/" + item.id + "/results"
      };
  }
};

class SurveyList extends React.Component {
  render() {
    const surveys = this.props.surveys;
    

    const menu = (
      <Menu>
        <Menu.Item key="0">
          <a href="/360/survey">
            {this.props.language === "en"
              ? " 360° Leadership Assessment"
              : "360° Lederskab Evaluering "}
          </a>
        </Menu.Item>

        <Menu.Divider />

        {/* Makes sure that every user can't have 2 TA */}
        {this.props.isTa ? (
          <Menu.Item key="1" disabled={this.props.hasFilledTa}>
            {this.props.hasFilledTa ? (
              <a>
                {this.props.language === "en"
                  ? " Transactional Analysis (Already filled out)"
                  : "Transactional Analysis (Denne er udfyldt)"}
              </a>
            ) : (
              <a href="/profile/survey">
                {this.props.language === "en"
                  ? " Transactional Analysis"
                  : "Transactional Analysis"}
              </a>
            )}
          </Menu.Item>
        ) : null}

        {/* Graying out the menu.items at the correct conditions to prevent that drivers are done before TA and that they can't be done multiple times. */}
        {this.props.isTa ? (
          <Menu.Item
            key="2"
            disabled={!this.props.hasFilledTa || this.props.hasFilled24}
          >
            {this.props.hasFilledTa ? (
              this.props.hasFilled24 ? (
                <a>
                  {this.props.language === "en"
                    ? "Transactional Analysis 24 Questions Driver  (Already filled out)"
                    : "Transactional Analysis 24 Questions Driver (Denne er udfyldt)"}
                </a>
              ) : (
                <a href="/twentyfivesections/survey">
                  {this.props.language === "en"
                    ? "Transactional Analysis 25 Questions Driver"
                    : "Transactional Analysis 25 Questions Driver"}
                </a>
              )
            ) : (
              <a>
                {this.props.language === "en"
                  ? "Transactional Analysis 25 Statements Driver (Fill Transactional Analysis for acces to drivers)"
                  : "Transactional Analysis  25 Statements Driver (Udfyld Transactional Analysis for adgang til drivers)"}
              </a>
            )}
          </Menu.Item>
        ) : null}

        {this.props.isTa ? (
          <Menu.Item
            key="3"
            disabled={!this.props.hasFilledTa || this.props.hasFilled12}
          >
            {this.props.hasFilledTa ? (
              this.props.hasFilled12 ? (
                <a>
                  {this.props.language === "en"
                    ? "Transactional Analysis 12 Sections Driver  (Already filled out)"
                    : "Transactional Analysis 12 Sections Driver (Denne er udfyldt)"}
                </a>
              ) : (
                <a href="/twelvesections/survey">
                  {this.props.language === "en"
                    ? " Transactional Analysis 12 Sections Driver"
                    : "Transactional Analysis 12 Sections Driver"}
                </a>
              )
            ) : (
              <a>
                {this.props.language === "en"
                  ? "Transactional Analysis 12 Sections Driver  (Fill Transactional Analysis for acces to drivers)"
                  : "Transactional Analysis 12 Sections Driver (Udfyld Transactional Analysis for adgang til drivers)"}
              </a>
            )}
          </Menu.Item>
        ) : null}
      </Menu>
    );

    return (
      <div
        style={{ backgroundColor: "black", height: "-webkit-fill-available" }}
      >
        <p style={{ color: "white" }}>
          {this.props.language === "en" ? "Your surveys" : "Dine evalueringer"}
        </p>
        {Object.keys(surveys).length !== 0 ? (
          <List
            position="both"
            grid={{
              gutter: 16,
              column: 4
            }}
            dataSource={surveys}
            renderItem={item => (
              <List.Item>
                <Link to={getChartForm(item).link}>
                  {getChartForm(item).chart}
                </Link>

                <p style={{ color: "white", marginBottom: "-3px" }}>
                  {" "}
                  {getChartForm(item).headline}
                </p>

                <p style={{ color: "#8c8c8c" }}>
                  {item.createTime.toString().split(" ", 4)[1] +
                    " " +
                    item.createTime.toString().split(" ", 4)[2] +
                    " " +
                    item.createTime.toString().split(" ", 4)[3]}
                </p>
              </List.Item>
            )}
          />
        ) : (
          <h3 style={{ color: "white", margin: "100px" }}>
            {this.props.language === "en"
              ? "You have not filled a survey yet"
              : "Du har endnu ikke udfyldt en evaluering"}
          </h3>
        )}
        <p style={{ color: "#8c8c8c", paddingBottom: "0px" }}>
          {this.props.language === "dk"
            ? "Vil du udfyld en ny evaluering? "
            : "Do you want to fill a new evaluation? "}

          <Dropdown overlay={menu}>
            <a style={{ color: "white" }} className="ant-dropdown-link">
              {this.props.language === "en"
                ? "Choose evaluationtype"
                : "Vælg evalueringstype"}
              <Icon type="down" />
            </a>
          </Dropdown>
        </p>
        ,
      </div>
    );
  }
}

export default SurveyList;



// WEBPACK FOOTER //
// ./src/pages/FrontPage/SurveyList/SurveyList.js